package team.platforma.aicombo.activity.main.component.generation

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.magicpen_filled
import aicombo.composeapp.generated.resources.magicpen_outlined
import aicombo.composeapp.generated.resources.navigation_generation_title
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.extra_nav.component.component_of_activity.Component

object GenerationComponent : Component(
    route = "generation_component",
    fragments = listOf(),
    isButton = true,
    label = Res.string.navigation_generation_title,
    icon = { selected ->
        Box(
            modifier = Modifier.fillMaxSize().then(
                if (selected) {
                    Modifier.background(AppColors.bg.primary().default, RoundedCornerShape(100))
                } else {
                    Modifier.border(1.dp, AppColors.border().dark, RoundedCornerShape(100))
                }
            ),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(if (selected) Res.drawable.magicpen_filled else Res.drawable.magicpen_outlined),
                contentDescription = null,
                tint = if (selected) AppColors.text().light else AppColors.text().default,
                modifier = Modifier.size(16.dp)
            )
        }
    }
)